<template>
    <slot v-bind="{
        ...state,
        setContainer,
    }" />
</template>

<script setup>
import { nextTick, onBeforeMount, reactive } from 'vue';
import { stringify } from 'qs-esm';
import { orderBy } from 'lodash';

import zonedDate from '../utils/zoned-date';
import { initialiseScroller } from '../modules/scroller';

const TOTAL_POSTS = 10;

const props = defineProps({
    blogId: {
        type: String,
    },
    postId: {
        type: String,
    },
    tagIds: {
        type: Array,
        default: [],
    },
    categoryIds: {
        type: Array,
        default: [],
    },
});

const state = reactive({
    isLoading: true,
    articles: [],
});

let container;

const setContainer = element => {
    container = element;
}

const getPosts = async (tagId = null, categoryId = null, limit = 4) => {
    const params = {
        blogId: props.blogId,
        limit,
    }

    if (tagId) {
        params.tagId = tagId;
    }

    if (categoryId) {
        params.categoryId = categoryId;
    }

    const stringifiedQuery = stringify(params, { addQueryPrefix: true });

    const { docs } = await fetch(`/api/posts${stringifiedQuery}`).then(response => { // eslint-disable-line
        return response.json();
    });

    return docs;
}

onBeforeMount(async () => {
    let articles = {}

    for (const id of props.tagIds) {
        for (const post of await getPosts(id, null)) {
            if (post.id !== props.postId) {
                articles[post.id] = post;
            }
        }
    }

    for (const id of props.categoryIds) {
        for (const post of await getPosts(null, id)) {
            if (post.id !== props.postId) {
                articles[post.id] = post;
            }
        }
    }

    if (Object.keys(articles).length < TOTAL_POSTS) {
        for (const post of await getPosts(null, null, TOTAL_POSTS - Object.keys(articles).length)) {
            if (post.id !== props.postId) {
                articles[post.id] = post;
            }
        }
    }

    articles = Object.values(articles);

    articles = orderBy(articles, item => {
        return +zonedDate(item.publishDate);
    }, 'desc');

    state.articles = articles.slice(0, TOTAL_POSTS);
    state.isLoading = false;

    nextTick(() => {
        if (container) {
            initialiseScroller(container);
        }
    });
});
</script>
